import { render, staticRenderFns } from "./ModalVuetifyModalLayerLegacy.vue?vue&type=template&id=28d6daf5&scoped=true"
import script from "./ModalVuetifyModalLayerLegacy.vue?vue&type=script&lang=js"
export * from "./ModalVuetifyModalLayerLegacy.vue?vue&type=script&lang=js"
import style0 from "./ModalVuetifyModalLayerLegacy.vue?vue&type=style&index=0&id=28d6daf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d6daf5",
  null
  
)

export default component.exports